module.exports = __webpack_public_path__ + "img/icon-72x72.05ab1586.png";